/// <reference path="../../types.d.ts"" />
import history from '../../history';
import { connect } from 'react-redux';
import { Admin } from './Admin';
import { buildDispatchable } from '../../actions/_action-utilities';
import { changeAdminTab, navigate } from '../../actions/ui';
import { getFeaturesBySection } from '../../actions/organization';
import { syncActions as externalAppSyncActions } from '../../actions/external-applications';
import { loadDictionaries } from '../../actions/dictionary';
const mapStateToProps = function(state) {
    const { organization, ui } = state;
    return {
        ...organization,
        auth: state.login.auth,
        actionGroups: ui.actionGroups,
        adminTabs: ui.AdminTabs,
        serviceLine: ui.serviceLine
    };
};
const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        selectTab: (navPath, activeSubAction, adminTabs)=>{
            runDispatchable(()=>{
                history.push('/cmx/' + navPath);
                dispatch(navigate(activeSubAction));
                return dispatch(changeAdminTab(adminTabs));
            });
        },
        navigateExternalApplication: (orgId)=>{
            runDispatchable(()=>{
                dispatch(externalAppSyncActions.selectOrgnization(orgId));
                history.push(`/cmx/admin/orgs/${orgId}/external-applications`);
            });
        },
        navigateCaseConfig: (orgId)=>{
            runDispatchable(()=>{
                history.push(`/cmx/admin/orgs/${orgId}/case-config`);
            });
        },
        navigateDictionaries: (org)=>{
            runDispatchable(()=>{
                //@ts-ignore
                return dispatch(loadDictionaries(org));
            });
        },
        navigateGroups: (orgId)=>{
            runDispatchable(()=>{
                //@ts-ignore
                history.push(`/cmx/admin/orgs/${orgId}/groups`);
            });
        },
        navigateFeatures: (section, orgId)=>{
            runDispatchable(()=>{
                history.push(`/cmx/admin/orgs/${orgId}/features`);
                return dispatch(getFeaturesBySection(section));
            });
        },
        navigateConfigurations: (orgId)=>{
            runDispatchable(()=>{
                history.push(`/cmx/admin/orgs/${orgId}/configurations`);
            });
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(Admin);
